import { z } from "zod";
import { InvoiceDraftSchema } from "../schemas";

export const InvoiceDraftSaveSchema = z
  .object({
    documentId: z.string().min(1).max(200).nullable(),
    revision: z
      .string()
      .regex(/^edit-[a-f0-9]{64}$/)
      .nullable(),
    invoice: InvoiceDraftSchema,
    partnerId: z.string().min(1).max(200).optional(),
  })
  .strict()
  .superRefine((value, ctx) => {
    if ((value.documentId === null) !== (value.revision === null))
      ctx.addIssue({
        code: "custom",
        path: ["revision"],
        message: "Reload the saved document before saving changes.",
      });
  });
const attempt = z.object({
  tenantId: z.string().min(1),
  actorId: z.string().min(1),
  attemptKey: z.string().uuid(),
  recordedAt: z.string().datetime(),
});
export const InvoiceDraftAttemptSchema = z.discriminatedUnion("state", [
  attempt.extend({
    state: z.literal("SAVED"),
    documentId: z.string().min(1),
    documentNumber: z.string(),
    revision: z.string().regex(/^edit-[a-f0-9]{64}$/),
  }),
  attempt.extend({ state: z.literal("CANCELLED") }),
]);
export type InvoiceDraftSave = z.infer<typeof InvoiceDraftSaveSchema>;
export type InvoiceDraftAttempt = z.infer<typeof InvoiceDraftAttemptSchema>;
